<div class="checkbox-list">
  <div class="checkbox-list-header">
    <div class="filter-checkbox">
      @if (compData?.containerItem?.title) {
        <div
          class="flex-container ion-align-items-center ion-justify-content-between filter-header">
          <p class="title">{{ compData?.containerItem?.title | titlecase }}</p>
          @if (!isCollapsed) {
            <span class="collapse-icon" (click)="toggleCollapsed();">
              <span class="arrow-down-icon"></span>
            </span>
          }
          @if (isCollapsed) {
            <span class="collapse-icon" (click)="toggleCollapsed();">
              <span class="arrow-up-icon"></span>
            </span>
          }
        </div>
      }
      @if (!isCollapsed) {
        @if (compData?.containerItem?.showSearchBar) {
          <div class="search-bar">
            <input type="text" #searchKey (keyup)="onTextChangeFunc(searchKey?.value)" placeholder="Search">
            <span class="search-icon"></span>
            @if (searchKey?.value) {
              <span class="close-icon"
              (click)="searchKey.value = null; onTextChangeFunc(searchKey.value);">&#10005;</span>
            }
          </div>
        }
      }
    </div>
  </div>

  <!--selectedIds ==> {{ selectedIds | json }}-->

  @if (!isCollapsed) {
    @for (option of displayOptions | slice:0:limitTo; track option; let i = $index; let l = $last) {
      <div (click)="onItemClickFunc(option, i)"
        class="checkbox-type">
        <div [ngClass]="{ 'selected-checkbox': selectedIds?.indexOf(option?._id + '') > -1 }">
          <div class="checkbox-item">
            <input class="inp-cbx" type="checkbox" [checked]="selectedIds?.indexOf(option?._id + '') > -1">
            <div class="cbx">
              <span>
                <svg width="12px" height="10px" viewbox="0 0 12 10">
                  <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                </svg>
              </span>
              <span class="title-case">{{ option?.title | titlecase }}</span>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="show-link">
      @if (limitTo < compData?.containerItem?.options?.length) {
        <div (click)="onShowAll()">
          <p>Show All+</p>
        </div>
      }
      @if (displayShowLess) {
        <div (click)="onShowLess()">
          <p>Show Less</p>
        </div>
      }
    </div>
  }
</div>
